import script from "./button-hide-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./button-hide-bar.vue?vue&type=script&setup=true&lang=js"

import "./button-hide-bar.vue?vue&type=style&index=0&id=05c3086c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c3086c"]])

export default __exports__